<!--
===========================================================================
  Tibia Calcs GPL Source Code
  Copyright (C) 2020 Lucas Soares de Miranda
  Copyright (C) 2020 Luiz Claudio Soares de Miranda

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <http://www.gnu.org/licenses/>.

  License available on https://github.com/lucasoares/tibia-calcs/blob/main/LICENSE.md
===========================================================================
-->

<template >
  <div class="stamina">
    <h1 id="main-title">
      Stamina Calculator
    </h1>
    <v-card>
      <v-tabs v-model="tab" color="deep-purple-accent-4" align-tabs="end">
        <v-tab class="d-none" :value="0">Landscape</v-tab>
        <v-tab :value="1">Targe Stamina</v-tab>
        <v-tab :value="2">Stamina At</v-tab>
      </v-tabs>
      <v-window v-model="tab">
        <v-window-item :key="1" :value="1" style="height:25vw">
          <v-row>
            <v-col cols="12" md="12">
              <h3>Calculator</h3>
              <v-row dense>
                <v-col cols="4" offset="4">
                  <v-row no-gutters>
                    <v-text-field type="string" label="Current stamina:" v-on:change="updateStoreStart"
                      v-model="stamina.start" />
                  </v-row>
                  <v-row no-gutters>
                    <v-text-field type="string" label="Target stamina:" v-on:change="updateStoreEnd"
                      v-model="stamina.end" />
                  </v-row>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="4" offset="4">
                  <v-row no-gutters>
                    <label>{{ calcFullStaminaDate(findTimeToRenegerateTargetStamina() * 60 * 1000)
                    }}</label>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-window-item>
        <v-window-item :key="2" :value="2" style="height:25vw">
          <v-container fluid>
            <v-row>
              <v-col cols="12" md="12">
                <h3>Calculator</h3>
                <v-row dense>
                  <v-col cols="4" offset="4">
                    <v-row no-gutters>
                      <v-text-field type="string" label="Current stamina:" v-on:change="updateStoreStart"
                        v-model="stamina.start" />
                    </v-row>
                    <v-row no-gutters>
                      <v-text-field type="string" label="Target hour:" v-on:change="updateStoreTargetHour"
                        v-model="stamina.targetHour" />
                    </v-row>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4" offset="4">
                    <v-row no-gutters>
                      <label>{{ calcStaminaInTime() }}</label>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-window-item>
      </v-window>
    </v-card>

    <div class="ad-container">
      <Adsense style="text-align:center;" data-ad-client="ca-pub-1611927435750729" data-ad-slot="7936683191"
        data-ad-format="auto">
      </Adsense>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import calculateStamitaWithTarget from '@/utils/stamina/stamina';

export default {
  name: 'Stamina',
  data: () => ({
    selected: 0,
    tier: 3,
    chance: true,
    tab: 1,
  }),
  computed: {
    ...mapGetters('stamina', { stamina: 'getState' }),
  },
  methods: {
    ...mapActions('stamina', ['updateStart', 'updateEnd', 'updatetargetHour']),
    updateStoreStart() {
      this.updateStart(this.stamina.start);
    },
    updateStoreEnd() {
      this.updateEnd(this.stamina.end);
    },
    updateStoreTargetHour() {
      this.updatetargetHour(this.stamina.targetHour);
    },
    getResult() {
      return this.stamina.end;
    },
    findTimeToRenegerateTargetStamina() {
      const currentStamina = this.stamina.start;
      const targetStamina = this.stamina.end;
      const currentHours = parseInt(currentStamina.substring(0, 2), 10);
      const currentMinutes = parseInt(currentStamina.substring(3, 5), 10);
      let hoursRemaining = 0;
      let minutesRemaining = 0;
      const targetHours = parseInt(targetStamina.substring(0, 2), 10);
      const targetMinutes = parseInt(targetStamina.substring(3, 5), 10);

      if ((currentMinutes > 60) || (targetMinutes > 60)) {
        return 'invalid input';
      }
      if (currentHours >= 42) {
        return '0';
      }
      if ((currentHours < 39) && (targetHours < 39)) {
        hoursRemaining = targetHours - currentHours;
        minutesRemaining = targetMinutes - currentMinutes;
        return ((hoursRemaining * 180) + (minutesRemaining * 3));
      }
      if ((currentHours >= 39) && (targetHours >= 39)) {
        hoursRemaining = targetHours - currentHours;
        minutesRemaining = targetMinutes - currentMinutes;
        return ((hoursRemaining * 360) + (minutesRemaining * 6));
      }

      hoursRemaining = 38 - currentHours;
      minutesRemaining = 60 - currentMinutes;

      return ((hoursRemaining * 180) + (minutesRemaining * 3) + ((targetHours - 39) * 360) + (targetMinutes * 6));
    },
    calcStaminaInTime() {
      const currentStaminaStr = this.stamina.start;
      const targetDateStr = this.stamina.targetHour;

      return calculateStamitaWithTarget(new Date(), currentStaminaStr, targetDateStr);
    },
    calcFullStaminaDate(millisToFullStamina) {
      const now = new Date();
      const fullStaminaTimestamp = now.getTime() + millisToFullStamina;
      return new Date(fullStaminaTimestamp).toLocaleString();
    },
  },
};
</script>

<style scoped>
.materials-divider {
  margin-bottom: 10px;
}

h1,
h3,
h4 {
  text-align: center;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
